import {
  select,
  fork,
  call,
  put,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";
import TutorialDataService from "../requests/staff";

function* handleGetStaff(action) {
  try {
    const staff = yield call(TutorialDataService.getAllStaff);

    if (staff.data) yield put({ type: "GET_Staff_SUCCESS", staff: staff.data });
  } catch (err) {
    yield put({ type: "GET_Staff_FAILED", message: err.message });
  }
}

function* handleLogin(action) {
  try {
    const login = yield call(TutorialDataService.login, action.loginobject);

    yield put({ type: "LOGIN_SUCCESS", login: login.data });
  } catch (err) {
    yield put({ type: "LOGIN_FAILED", message: err.message });
  }
}

function* handleGetSuppliers(action) {
  try {
    const suppliers = yield call(TutorialDataService.getAllSuppliers);

    yield put({ type: "GET_SUPPLIERS_SUCCESS", suppliers: suppliers.data });
  } catch (err) {
    yield put({ type: "GET_SUPPLIERS_FAILED", message: err.message });
  }
}

function* handleGetProducts(action) {
  try {
    const products = yield call(TutorialDataService.getAllProducts);

    yield put({ type: "GET_Products_SUCCESS", products: products.data });
  } catch (err) {
    yield put({ type: "GET_Products_FAILED", message: err.message });
  }
}

function* handleGetWarehouses(action) {
  try {
    // const getIsLogin = (state) => state.staff.login.Login.id;
    // const isLogin = yield select(getIsLogin);

    const warehouses = yield call(TutorialDataService.getAllWarehouse);

    yield put({ type: "GET_WAREHOUSES_SUCCESS", warehouses: warehouses.data });
  } catch (err) {
    yield put({ type: "GET_WAREHOUSES_FAILED", message: err.message });
  }
}

function* handlegetAllWareHouseManager(action) {
  try {
    // const getIsLogin = (state) => state.staff.login.Login.id;
    // const isLogin = yield select(getIsLogin);

    const warehousesManager = yield call(
      TutorialDataService.getAllWareHouseManager
    );

    yield put({
      type: "GET_ALLWAREHOUSES_MANAGER_SUCCESS",
      warehousesManager: warehousesManager.data,
    });
  } catch (err) {
    yield put({
      type: "GET_ALLWAREHOUSES_MANAGER_FAILED",
      message: err.message,
    });
  }
}

function* handlegetAllTransporters(action) {
  try {
    const transporters = yield call(TutorialDataService.getAllTransporters);

    yield put({
      type: "GET_ALLTRANSPORTERS_SUCCESS",
      transporters: transporters.data,
    });
  } catch (err) {
    yield put({
      type: "GET_ALLTRANSPORTERS_FAILED",
      message: err.message,
    });
  }
}

function* handlePostRealWarehouse(action) {
  try {
    // const getIsLogin = (state) => state.staff.login.Login.id;
    // const isLogin = yield select(getIsLogin);

    const realWarehouse = yield call(
      TutorialDataService.addRealWarehouse,
      action.warehouseModel
    );

    yield put({
      type: "POST_REAL_WAREHOUSE_SUCCESS",
      realWarehouse: realWarehouse.data,
    });
  } catch (err) {
    yield put({
      type: "POST_REAL_WAREHOUSE_FAILED",
      message: err.message,
    });
  }
}

function* handlePostProductPurchaseToVWareHouse(action) {
  try {
    // const getIsLogin = (state) => state.staff.login.Login.id;
    // const isLogin = yield select(getIsLogin);
    // action.ProductPurchaseModel.idUserCreation = isLogin;

    const productPurchaseToVWarehouse = yield call(
      TutorialDataService.addProductPurchaseToVWareHouse,
      action.ProductPurchaseModel
    );

    yield put({
      type: "POST_PRODUCT_PURCHASE_TOVWAREHOUSE_SUCCESS",
      productPurchaseToVWarehouse: productPurchaseToVWarehouse.data,
    });
  } catch (err) {
    yield put({
      type: "POST_PRODUCT_PURCHASE_TOVWAREHOUSEOST_REAL_WAREHOUSE_FAILED",
      message: err.message,
    });
  }
}

function* getProductQuantitytByWarehouse(action) {
  try {
    const ProductQuantitytByWarehouse = yield call(
      TutorialDataService.getProductQuantitytByWarehouse,
      action.ProductQteAndWarehouse
    );

    yield put({
      type: "GET_PRODUCT_QUANTITY_BY_WAREHOUSE_SUCCESS",
      ProductQuantitytByWarehouse: ProductQuantitytByWarehouse.data,
    });
  } catch (err) {
    yield put({
      type: "GET_PRODUCT_QUANTITY_BY_WAREHOUSE_FAILED",
      message: err.message,
    });
  }
}

function* getProductsByWarehouse(action) {
  // const getIsLogin = (state) => state.staff.login.Login.id;
  // const isLogin = yield select(getIsLogin);
  try {
    const productsByWarehouse = yield call(
      TutorialDataService.getProductsByWarehouse,

      action.idWarehouse
    );

    yield put({
      type: "GET_PRODUCTS_BY_WAREHOUSE_SUCCESS",
      productsByWarehouse: productsByWarehouse.data,
    });
  } catch (err) {
    yield put({
      type: "GET_PRODUCTS_BY_WAREHOUSE_FAILED",
      message: err.message,
    });
  }
}

function* handleAddWarehouseTransaction(action) {
  try {
    // const getIsLogin = (state) => state.staff.login.Login.id;
    // const isLogin = yield select(getIsLogin);
    // action.warehouseTransactionModel.userCreation = isLogin;

    const warehouseTransaction = yield call(
      TutorialDataService.addWarehouseTransaction,
      action.warehouseTransactionModel
    );

    yield put({
      type: "POST_ASKING_WAREHOUSE_TRANSACTION_SUCCESS",
      warehouseTransaction: warehouseTransaction.data,
    });
  } catch (err) {
    yield put({
      type: "POST_ASKING_WAREHOUSE_TRANSACTION_FAILED",
      message: err.message,
    });
  }
}

function* handleGetAllBrands(action) {
  try {
    const brands = yield call(
      TutorialDataService.getAllBrands,

      action.isDeleted
    );

    yield put({
      type: "GET_ALLBRANDS_SUCCESS",
      brands: brands.data.brand,
      isDeleted: action.isDeleted,
    });
  } catch (err) {
    yield put({
      type: "GET_ALLBRANDS_FAILED",
      message: err.message,
    });
  }
}

function* handleAddProductBrand(action) {
  try {
    // const getIsLogin = (state) => state.staff.login.Login.id;
    // const isLogin = yield select(getIsLogin);
    // action.productModel.idUserCreation = isLogin;

    const addBrand = yield call(
      TutorialDataService.addProductBrand,
      action.productModel
    );

    yield put({
      type: "POST_BRAND_SUCCESS",
      brand: addBrand.data,
    });
  } catch (err) {
    yield put({
      type: "POST_BRAND_FAILED",
      message: err.message,
    });
  }
}

function* handleSetBrandNotificationState(action) {
  try {
    yield put({
      type: "SET_BRAND_NOTIFICATION_SUCCESS",
      notificationSetter: null,
    });
  } catch (err) {
    yield put({
      type: "SET_BRAND_NOTIFICATION_FAILED",
      message: err.message,
    });
  }
}

function* handleSetBrandIsDeletedField(action) {
  try {
    const deletedAndRestoredBrand = yield call(
      TutorialDataService.setBrandIsDeletedField,

      action.deletedAndRestoreModel
    );

    yield put({
      type: "SET_BRANDS_ISDELETED_SUCCESS",
      deletedAndRestoredBrand: deletedAndRestoredBrand.data,
      isDeleted: action.deletedAndRestoreModel.isDeleted,
      idBrand: action.deletedAndRestoreModel.idBrand,
    });
  } catch (err) {
    yield put({
      type: "SET_BRANDS_ISDELETED_FAILED",
      message: err.message,
    });
  }
}

function* handleUpdateBrandData(action) {
  try {
    const updatedBrand = yield call(
      TutorialDataService.updateBrandData,

      action.updateBrandModel
    );

    yield put({
      type: "UPDATE_BRAND_SUCCESS",
      updatedBrand: updatedBrand.data,

      idBrand: action.updateBrandModel.idBrand,
    });
  } catch (err) {
    yield put({
      type: "UPDATE_BRAND_FAILED",
      message: err.message,
    });
  }
}

function* handleAddProductFamily(action) {
  try {
    // const getIsLogin = (state) => state.staff.login.Login.id;
    // const isLogin = yield select(getIsLogin);
    // action.familyModel.idUserCreation = isLogin;

    const addFamily = yield call(
      TutorialDataService.addProductFamily,
      action.familyModel
    );

    yield put({
      type: "POST_FAMILY_SUCCESS",
      family: addFamily.data,
    });
  } catch (err) {
    yield put({
      type: "POST_FAMILY_FAILED",
      message: err.message,
    });
  }
}

function* handleGetAllFamilies(action) {
  try {
    const families = yield call(
      TutorialDataService.getAllFamilies,

      action.isDeleted
    );

    yield put({
      type: "GET_ALL_FAMILIES_SUCCESS",
      families: families.data.productFamily,
      isDeleted: action.isDeleted,
    });
  } catch (err) {
    yield put({
      type: "GET_ALL_FAMILIES_FAILED",
      message: err.message,
    });
  }
}

function* handleSetFamilyIsDeletedField(action) {
  try {
    const deletedAndRestoredFamily = yield call(
      TutorialDataService.setFamilyIsDeletedField,

      action.deletedAndRestoreModel
    );

    yield put({
      type: "SET_FAMILY_ISDELETED_SUCCESS",
      deletedAndRestoredFamily: deletedAndRestoredFamily.data,
      isDeleted: action.deletedAndRestoreModel.isDeleted,
      idFamily: action.deletedAndRestoreModel.idFamily,
    });
  } catch (err) {
    yield put({
      type: "SET_FAMILY_ISDELETED_FAILED",
      message: err.message,
    });
  }
}

function* handleUpdateFamilyData(action) {
  try {
    const updatedFamily = yield call(
      TutorialDataService.updateFamilyData,

      action.updateFamilyModel
    );

    yield put({
      type: "UPDATE_FAMILY_SUCCESS",
      updatedFamily: updatedFamily.data,

      idFamily: action.updateFamilyModel.idFamily,
    });
  } catch (err) {
    yield put({
      type: "UPDATE_FAMILY_FAILED",
      message: err.message,
    });
  }
}

function* handleGetAllSubFamilies(action) {
  try {
    // const getIsLogin = (state) => state.staff.login.Login.id;
    // const isLogin = yield select(getIsLogin);

    const subFamilies = yield call(
      TutorialDataService.getAllSubFamilies,

      action.isDeleted
    );

    yield put({
      type: "GET_ALL_SUB_FAMILIES_SUCCESS",
      subFamilies: subFamilies.data.productSubFamily,
      isDeleted: action.isDeleted,
    });
  } catch (err) {
    yield put({
      type: "GET_ALL_SUB_FAMILIES_FAILED",
      message: err.message,
    });
  }
}
function* handleGetAllSubFamiliesByFamilyId(action) {
  try {
    const subFamilies = yield call(
      TutorialDataService.getAllSubFamiliesByFamilyId,

      action.idFamily
    );

    yield put({
      type: "GET_ALL_SUB_FAMILIES_BY_FAMILY_ID_SUCCESS",
      subFamilies: subFamilies.data.productSubFamily,
      idFamily: action.idFamily,
    });
  } catch (err) {
    yield put({
      type: "GET_ALL_SUB_FAMILIES_BY_FAMILY_ID_FAILED",
      message: err.message,
    });
  }
}

function* handleGetAllCategoriesBySubFamilyId(action) {
  try {
    const categories = yield call(
      TutorialDataService.getAllCategoriesBySubFamilyId,

      action.idSubFamily
    );

    yield put({
      type: "GET_ALL_CATEGORIES_BY_SUBFAMILY_ID_SUCCESS",
      categories: categories.data.productCategory,
      idSubFamily: action.idSubFamily,
    });
  } catch (err) {
    yield put({
      type: "GET_ALL_CATEGORIES_BY_SUBFAMILY_ID_FAILED",
      message: err.message,
    });
  }
}

function* handleGetProductById(action) {
  try {
    const product = yield call(
      TutorialDataService.getProductById
      // sessionStorage.getItem("idProduct")
      // action.idProduct
    );

    yield put({
      type: "GET_PRODUCT_BY_ID_SUCCESS",
      product: product.data.Product,
      // idProduct: sessionStorage.getItem("idProduct"),
    });
  } catch (err) {
    yield put({
      type: "GET_PRODUCT_BY_ID_FAILED",
      message: err.message,
    });
  }
}

function* handleSetSubFamilyIsDeletedField(action) {
  try {
    const deletedAndRestoredSubFamily = yield call(
      TutorialDataService.setSubFamilyIsDeletedField,

      action.deletedAndRestoreModel
    );

    yield put({
      type: "SET_SUB_FAMILY_ISDELETED_SUCCESS",
      deletedAndRestoredSubFamily: deletedAndRestoredSubFamily.data,
      isDeleted: action.deletedAndRestoreModel.isDeleted,
      idSubFamily: action.deletedAndRestoreModel.idSubFamily,
    });
  } catch (err) {
    yield put({
      type: "SET_SUB_FAMILY_ISDELETED_FAILED",
      message: err.message,
    });
  }
}

function* handleAddProductSubFamily(action) {
  try {
    const addSubFamily = yield call(
      TutorialDataService.addProductSubFamily,
      action.subFamilyModel
    );
    yield put({
      type: "POST_SUB_FAMILY_SUCCESS",
      subFamily: addSubFamily.data,
    });
  } catch (err) {
    yield put({
      type: "POST_SUB_FAMILY_FAILED",
      message: err.message,
    });
  }
}

function* handleUpdateSubFamilyData(action) {
  try {
    const updatedSubFamily = yield call(
      TutorialDataService.updateSubFamilyData,

      action.updateSubFamilyModel
    );

    yield put({
      type: "UPDATE_SUB_FAMILY_SUCCESS",
      updatedSubFamily: updatedSubFamily.data,

      idSubFamily: action.updateSubFamilyModel.idSubFamily,
    });
  } catch (err) {
    yield put({
      type: "UPDATE_SUB_FAMILY_FAILED",
      message: err.message,
    });
  }
}

function* handleUpdateCategoryData(action) {
  try {
    const updatedCategory = yield call(
      TutorialDataService.updateCategoryData,

      action.updateCategoryModel
    );

    yield put({
      type: "UPDATE_CATEGORY_SUCCESS",
      updatedCategory: updatedCategory.data,

      idCategory: action.updateCategoryModel.idCategory,
    });
  } catch (err) {
    yield put({
      type: "UPDATE_CATEGORY_FAILED",
      message: err.message,
    });
  }
}

function* handleGetAllCategories(action) {
  try {
    // const getIsLogin = (state) => state.staff.login.Login.id;
    // const isLogin = yield select(getIsLogin);

    const categories = yield call(
      TutorialDataService.getAllCategories,

      action.isDeleted
    );

    yield put({
      type: "GET_ALL_CATEGORIES_SUCCESS",
      categories: categories.data.productCategory,
      isDeleted: action.isDeleted,
    });
  } catch (err) {
    yield put({
      type: "GET_ALL_CATEGORIES_FAILED",
      message: err.message,
    });
  }
}

function* handleSetCategoryIsDeletedField(action) {
  try {
    const deletedAndRestoredCategory = yield call(
      TutorialDataService.setCategoryIsDeletedField,

      action.deletedAndRestoreModel
    );

    yield put({
      type: "SET_CATEGORY_ISDELETED_SUCCESS",
      deletedAndRestoredCategory: deletedAndRestoredCategory.data,
      isDeleted: action.deletedAndRestoreModel.isDeleted,
      idCategory: action.deletedAndRestoreModel.idCategory,
    });
  } catch (err) {
    yield put({
      type: "SET_CATEGORY_ISDELETED_FAILED",
      message: err.message,
    });
  }
}

function* handleAddProductCategory(action) {
  try {
    // const getIsLogin = (state) => state.staff.login.Login.id;
    // const isLogin = yield select(getIsLogin);
    // action.categoryModel.idUserCreation = isLogin;

    const AddCategory = yield call(
      TutorialDataService.addProductCategory,
      action.categoryModel
    );
    yield put({
      type: "POST_CATEGORY_SUCCESS",
      category: AddCategory.data,
    });
  } catch (err) {
    yield put({
      type: "POST_CATEGORY_FAILED",
      message: err.message,
    });
  }
}

function* handleAddProduct(action) {
  try {
    // const getIsLogin = (state) => state.staff.login.Login.id;
    // const isLogin = yield select(getIsLogin);
    // action.productModel.idUserCreation = isLogin;

    const addProduct = yield call(
      TutorialDataService.addProduct,
      action.productModel
    );

    yield put({
      type: "POST_PRODUCT_SUCCESS",
      product: addProduct.data,
    });
  } catch (err) {
    yield put({
      type: "POST_PRODUCT_FAILED",
      message: err.message,
    });
  }
}

function* handleGetAllProductsByFilter(action) {
  try {
    // const getIsLogin = (state) => state.staff.login.Login.id;
    // const isLogin = yield select(getIsLogin);
    // action.filterModel.idUser = isLogin;

    const products = yield call(
      TutorialDataService.getAllProductsByFilter,
      action.filterModel
    );

    yield put({
      type: "GET_ALL_PRODUCTS_BY_FILTER_SUCCESS",
      products: products.data.product,
      isDeleted: action.filterModel.isDeleted,
    });
  } catch (err) {
    yield put({
      type: "GET_ALL_PRODUCTS_BY_FILTER_FAILED",
      message: err.message,
    });
  }
}

function* handleSetProductIsDeletedField(action) {
  try {
    // const getIsLogin = (state) => state.staff.login.Login.id;
    // const isLogin = yield select(getIsLogin);

    const deletedAndRestoredProduct = yield call(
      TutorialDataService.setProductIsDeletedField,

      action.deletedAndRestoreModel
    );

    yield put({
      type: "SET_PRODUCT_ISDELETED_SUCCESS",
      deletedAndRestoredProduct: deletedAndRestoredProduct.data,
      isDeleted: action.deletedAndRestoreModel.isDeleted,
      idProduct: action.deletedAndRestoreModel.idProduct,
    });
  } catch (err) {
    yield put({
      type: "SET_PRODUCT_ISDELETED_FAILED",
      message: err.message,
    });
  }
}

function* handleGetAllRealWarehouses(action) {
  try {
    // const getIsLogin = (state) => state.staff.login.Login.id;
    // const isLogin = yield select(getIsLogin);

    const warehouses = yield call(
      TutorialDataService.getAllRealWarehouses,

      action.isDeleted
    );

    yield put({
      type: "GET_ALL_REAL_WAREHOUSE_SUCCESS",
      warehouses: warehouses.data.success,
      isDeleted: action.isDeleted,
    });
  } catch (err) {
    yield put({
      type: "GET_ALL_REAL_WAREHOUSE_FAILED",
      message: err.message,
    });
  }
}

function* handleSetRealWarehouseIsDeletedField(action) {
  try {
    // const getIsLogin = (state) => state.staff.login.Login.id;
    // const isLogin = yield select(getIsLogin);

    const deletedAndRestoredWarehouse = yield call(
      TutorialDataService.setRealWarehouseIsDeletedField,

      action.deletedAndRestoreModel
    );

    yield put({
      type: "SET_REAL_WAREHOUSE_ISDELETED_SUCCESS",
      deletedAndRestoredWarehouse: deletedAndRestoredWarehouse.data,
      isDeleted: action.deletedAndRestoreModel.isDeleted,
      idWarehouse: action.deletedAndRestoreModel.idWarehouse,
    });
  } catch (err) {
    yield put({
      type: "SET_REAL_WAREHOUSE_ISDELETED__FAILED",
      message: err.message,
    });
  }
}

function* handleUpdateRealWarehouseData(action) {
  try {
    // const getIsLogin = (state) => state.staff.login.Login.id;
    // const isLogin = yield select(getIsLogin);

    const updatedWarehouse = yield call(
      TutorialDataService.updateRealWarehouseData,

      action.updateWarehouseModel
    );

    yield put({
      type: "UPDATE_REAL_WAREHOUSE_SUCCESS",
      updatedWarehouse: updatedWarehouse.data.success,

      idWarehouse: action.updateWarehouseModel.idWarehouse,
    });
  } catch (err) {
    yield put({
      type: "UPDATE_REAL_WAREHOUSE_FAILED",
      message: err.message,
    });
  }
}

function* handleGetAllProductsByFamilyOrSubFamilyOrBrandOrCategory(action) {
  try {
    // const getIsLogin = (state) => state.staff.login.Login.id;
    // const isLogin = yield select(getIsLogin);
    let products = null;

    if (action.cible == "marque") {
      products = yield call(
        TutorialDataService.getAllProductsByBrandId,

        action.idElement
      );
    } else if (action.cible == "famille") {
      products = yield call(
        TutorialDataService.getAllProductsByFamilyId,

        action.idElement
      );
    } else if (action.cible == "catégorie") {
      products = yield call(
        TutorialDataService.getAllProductsByCategoryId,

        action.idElement
      );
    } else {
      products = yield call(
        TutorialDataService.getAllProductsBySubFamilyId,

        action.idElement
      );
    }

    yield put({
      type: "GET_ALL_PRODUCTS_BY_BRAND_ORBY_CATEGORY_ORBY_SUBFAMILY_ORBY_FAMILY_SUCCESS",
      products: products.data.products,
    });
  } catch (err) {
    yield put({
      type: "GET_ALL_PRODUCTS_BY_BRAND_ORBY_CATEGORY_ORBY_SUBFAMILY_ORBY_FAMILY_FAILED",
      message: err.message,
    });
  }
}

function* handleGetAllProductsByWarehouse(action) {
  try {
    // const getIsLogin = (state) => state.staff.login.Login.id;
    // const isLogin = yield select(getIsLogin);

    const products = yield call(
      TutorialDataService.getProductsByWarehouse,

      action.idWarehouse
    );

    yield put({
      type: "GET_ALL_PRODUCTS_BY_WAREHOUSE_SUCCESS",
      products: products.data.success,
    });
  } catch (err) {
    yield put({
      type: "GET_ALL_PRODUCTS_BY_WAREHOUSE_FAILED",
      message: err.message,
    });
  }
}

function* handleAddOrderPurchaseToWarehouse(action) {
  try {
    // const getIsLogin = (state) => state.staff.login.Login.id;
    // const isLogin = yield select(getIsLogin);
    // action.purchaseModel.idUser = isLogin;

    const AddOrderPurchase = yield call(
      TutorialDataService.addOrderPurchaseToWarehouse,
      action.purchaseOrderModel,
      action.picture
    );

    yield put({
      type: "POST_ORDER_PURCHASE_TO_WAREHOUSE_SUCCESS",
      orderPurchase: AddOrderPurchase.data,
    });
  } catch (err) {
    yield put({
      type: "POST_ORDER_PURCHASE_TO_WAREHOUSE_FAILED",
      message: err.message,
    });
  }
}

function* staffSaga() {
  yield takeLatest("GET_Staff_REQUESTED", handleGetStaff);
  yield takeLatest("LOGIN_REQUESTED", handleLogin);
  yield takeLatest("GET_SUPPLIERS_REQUESTED", handleGetSuppliers);
  yield takeLatest("GET_Products_REQUESTED", handleGetProducts);
  yield takeLatest("GET_WAREHOUSES_REQUESTED", handleGetWarehouses);
  yield takeLatest(
    "GET_ALLWAREHOUSES_MANAGER_REQUESTED",
    handlegetAllWareHouseManager
  );
  yield takeLatest("POST_REAL_WAREHOUSE_REQUESTED", handlePostRealWarehouse);
  yield takeLatest(
    "POST_PRODUCT_PURCHASE_TOVWAREHOUSE_REQUESTED",
    handlePostProductPurchaseToVWareHouse
  );

  yield takeLatest(
    "GET_PRODUCT_QUANTITY_BY_WAREHOUSE_REQUESTED",
    getProductQuantitytByWarehouse
  );

  yield takeLatest(
    "GET_PRODUCTS_BY_WAREHOUSE_REQUESTED",
    getProductsByWarehouse
  );

  yield takeLatest(
    "POST_ASKING_WAREHOUSE_TRANSACTION_REQUESTED",
    handleAddWarehouseTransaction
  );

  yield takeLatest("GET_ALLTRANSPORTERS_REQUESTED", handlegetAllTransporters);

  yield takeEvery("GET_ALLBRANDS_REQUESTED", handleGetAllBrands);

  yield takeLatest("POST_BRAND_REQUESTED", handleAddProductBrand);
  yield takeLatest(
    "SET_BRAND_NOTIFICATION_REQUESTED",
    handleSetBrandNotificationState
  );

  yield takeLatest(
    "SET_BRANDS_ISDELETED_REQUESTED",
    handleSetBrandIsDeletedField
  );

  yield takeLatest("UPDATE_BRAND_REQUESTED", handleUpdateBrandData);
  yield takeLatest("POST_FAMILY_REQUESTED", handleAddProductFamily);
  yield takeEvery("GET_ALL_FAMILIES_REQUESTED", handleGetAllFamilies);
  yield takeEvery(
    "SET_FAMILY_ISDELETED_REQUESTED",
    handleSetFamilyIsDeletedField
  );
  yield takeLatest("UPDATE_FAMILY_REQUESTED", handleUpdateFamilyData);

  //subFamily
  yield takeEvery("GET_ALL_SUB_FAMILIES_REQUESTED", handleGetAllSubFamilies);
  yield takeEvery(
    "GET_ALL_SUB_FAMILIES_BY_FAMILY_ID_REQUESTED",
    handleGetAllSubFamiliesByFamilyId
  );

  yield takeEvery(
    "SET_SUB_FAMILY_ISDELETED_REQUESTED",
    handleSetSubFamilyIsDeletedField
  );

  yield takeLatest("POST_SUB_FAMILY_REQUESTED", handleAddProductSubFamily);
  yield takeLatest("UPDATE_SUB_FAMILY_REQUESTED", handleUpdateSubFamilyData);
  //category
  yield takeLatest("UPDATE_CATEGORY_REQUESTED", handleUpdateCategoryData);

  yield takeEvery("GET_ALL_CATEGORIES_REQUESTED", handleGetAllCategories);
  yield takeEvery(
    "SET_CATEGORY_ISDELETED_REQUESTED",
    handleSetCategoryIsDeletedField
  );
  yield takeEvery(
    "GET_ALL_CATEGORIES_BY_SUBFAMILY_ID_REQUESTED",
    handleGetAllCategoriesBySubFamilyId
  );

  yield takeEvery("GET_PRODUCT_BY_ID_REQUESTED", handleGetProductById);

  yield takeLatest("POST_CATEGORY_REQUESTED", handleAddProductCategory);

  yield takeLatest("POST_PRODUCT_REQUESTED", handleAddProduct);
  yield takeLatest(
    "GET_ALL_PRODUCTS_BY_FILTER_REQUESTED",
    handleGetAllProductsByFilter
  );
  yield takeEvery(
    "SET_PRODUCT_ISDELETED_REQUESTED",
    handleSetProductIsDeletedField
  );

  // warehouses

  yield takeEvery(
    "GET_ALL_REAL_WAREHOUSE_REQUESTED",
    handleGetAllRealWarehouses
  );

  yield takeLatest(
    "SET_REAL_WAREHOUSE_ISDELETED_REQUESTED",
    handleSetRealWarehouseIsDeletedField
  );
  yield takeLatest(
    "UPDATE_REAL_WAREHOUSE_REQUESTED",
    handleUpdateRealWarehouseData
  );

  yield takeLatest(
    "GET_ALL_PRODUCTS_BY_BRAND_ORBY_CATEGORY_ORBY_SUBFAMILY_ORBY_FAMILY_REQUESTED",
    handleGetAllProductsByFamilyOrSubFamilyOrBrandOrCategory
  );

  yield takeLatest(
    "GET_ALL_PRODUCTS_BY_WAREHOUSE_REQUESTED",
    handleGetAllProductsByWarehouse
  );

  yield takeLatest(
    "POST_ORDER_PURCHASE_TO_WAREHOUSE_REQUESTED",
    handleAddOrderPurchaseToWarehouse
  );
}

export default staffSaga;
